(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["eu-shipping-popup"] && !Shopify.designMode) return;
  try {
    (() => {
    const initialiseEuShippingDialog = () => {
      const dialog = document.getElementById('gb-eu-shipping-dialog');
      if (!dialog || typeof dialog.showModal !== 'function') return;

      const storageKey = 'gb-eu-shipping-notice-seen-' + dialog.dataset.market;
      try {
        if (window.sessionStorage.getItem(storageKey)) return;
        window.sessionStorage.setItem(storageKey, 'true');
      } catch (error) {
        // Show the notice even if storage is unavailable.
      }

      dialog.querySelectorAll('[data-close-dialog]').forEach((button) => {
        button.addEventListener('click', () => dialog.close());
      });
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });

      window.setTimeout(() => dialog.showModal(), 500);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialiseEuShippingDialog, { once: true });
    } else {
      initialiseEuShippingDialog();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["us-import-duty-popup"] && !Shopify.designMode) return;
  try {
    (() => {
    const initialiseUsDutyDialog = () => {
      const dialog = document.getElementById('gb-us-duty-dialog');
      if (!dialog || typeof dialog.showModal !== 'function') return;

      const storageKey = 'gb-us-duty-notice-seen';

      try {
        if (window.sessionStorage.getItem(storageKey)) return;
        window.sessionStorage.setItem(storageKey, 'true');
      } catch (error) {
        // The notice can still be shown when browser storage is unavailable.
      }

      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });

      window.setTimeout(() => dialog.showModal(), 500);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialiseUsDutyDialog, { once: true });
    } else {
      initialiseUsDutyDialog();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
